<template>
  <v-select
    ref="select"
    v-model="selectedItems"
    :items="items"
    :menu-props="{ maxHeight: 500 }"
    hide-details
    label="What"
    multiple
    variant="outlined"
  >
    <template #selection="{ item }">
      {{ item.raw.group ? '(Select a product)' : item.title }}
    </template>

    <template #item="{ item }">
      <v-list-item @click="onItemClick(item)"
        ><template #title
          ><span
            :class="
              whatProducts
                ? ''
                : item.raw.group
                  ? 'font-weight-bold'
                  : item.raw.product
                    ? 'ml-6'
                    : ''
            "
            >{{ item.title }}</span
          ></template
        >
      </v-list-item>
    </template>
  </v-select>
</template>

<script setup>
import { computed, ref } from 'vue'
import { FILTER_WHAT_ALL } from '#root/lib/consts'

const emit = defineEmits(['select'])

const props = defineProps({
  whatItems: {
    default: undefined,
    type: Array
  },
  whatMenu: {
    default: undefined,
    type: Object
  },
  whatProducts: {
    default: undefined,
    type: Array
  }
})

const select = ref(null)
const selectedItems = ref([FILTER_WHAT_ALL])
const items = computed(() => {
  const items = [{ title: 'All Classes & Workshops', value: FILTER_WHAT_ALL }]

  if (props.whatItems) items.push(...props.whatItems)

  if (props.whatProducts) {
    for (const product of props.whatProducts) {
      if (product.status === 'published') {
        items.push({
          title: product.name,
          value: `0/${product.code}`,
          product: true
        })
      }
    }
  } else if (props.whatMenu && props.whatMenu.status === 'published') {
    for (const menuItem of props.whatMenu.menu_items) {
      if (
        menuItem.collection === 'menu_item_products' &&
        menuItem.item.status === 'published'
      ) {
        items.push({
          title: menuItem.item.title,
          value: `${menuItem.item.id}/`,
          group: true
        })

        if (selectedItems.value[0].startsWith(`${menuItem.item.id}`)) {
          for (const product of menuItem.item.products) {
            if (product.products_id.status === 'published') {
              items.push({
                title: product.products_id.name,
                value: `${menuItem.item.id}/${product.products_id.code}`,
                product: true
              })
            }
          }
        }
      }
    }
  }

  return items
})

function selectItem(value) {
  if (value === FILTER_WHAT_ALL) {
    selectedItems.value = [value]
  } else if (
    props.whatItems &&
    props.whatItems.find(item => item.value === value)
  ) {
    selectedItems.value = [value]
  } else if (props.whatProducts) {
    for (const product of props.whatProducts) {
      if (product.code === value) {
        selectedItems.value = [`0/${product.code}`]
        return
      }
    }
  } else if (props.whatMenu && props.whatMenu.status === 'published') {
    for (const menuItem of props.whatMenu.menu_items) {
      for (const product of menuItem.item.products) {
        if (
          product.products_id.status === 'published' &&
          product.products_id.code === value
        ) {
          selectedItems.value = [
            `${menuItem.item.id}/${product.products_id.code}`
          ]
          return
        }
      }
    }
  }
}
function onItemClick(item) {
  selectedItems.value = [item.value]

  if (item.raw.product) {
    emit('select', item.value.split('/')[1])
    select.value.blur()
  } else if (!item.raw.group) {
    emit('select', item.value)
    select.value.blur()
  }
}

defineExpose({ selectItem })
</script>
